import React from 'react';

export const LoadingState = ({ message = 'กำลังโหลดข้อมูล...' }) => (
    <div className="flex min-h-[220px] items-center justify-center rounded-2xl border border-slate-200 bg-white p-6 text-slate-600">
        <div className="flex items-center gap-3">
            <span className="h-5 w-5 animate-spin rounded-full border-2 border-slate-300 border-t-blue-600" />
            <span className="text-sm sm:text-base">{message}</span>
        </div>
    </div>
);

export const ErrorState = ({ message = 'เกิดข้อผิดพลาด', action }) => (
    <div className="rounded-2xl border border-red-200 bg-red-50 p-6 text-center text-red-700">
        <p className="font-semibold">{message}</p>
        {action ? <div className="mt-3">{action}</div> : null}
    </div>
);

export const EmptyState = ({ title = 'ยังไม่มีข้อมูล', description = '', action }) => (
    <div className="rounded-2xl border border-slate-200 bg-slate-50 p-6 text-center text-slate-600">
        <p className="font-semibold text-slate-700">{title}</p>
        {description ? <p className="mt-1 text-sm">{description}</p> : null}
        {action ? <div className="mt-3">{action}</div> : null}
    </div>
);
